import io from 'socket.io-client';

// ใส่ URL backend ของคุณ
// const socket = io(process.env.VUE_APP_SOCKET_URL || 'http://localhost:3001', {
//   transports: ['polling','websocket'],
//   reconnection: true,
//   reconnectionAttempts: 10,
//   reconnectionDelay: 800,
// });
const socket = io({
  path: '/socket.io',
  transports: ['websocket', 'polling'], // ให้ครบ
});


export default socket;